export default __webpack_public_path__ + "static/media/Status_On.bb90639d.svg";